export default __webpack_public_path__ + "static/addonexample-22a77d69aa552e8a37c36c3cda704c7e.png";